// extracted by mini-css-extract-plugin
export default {"root":"SearchBackLink_root__E5Nrt","link":"SearchBackLink_link__PYFbm","chevron":"SearchBackLink_chevron__wuBvT"};